import { type LucideIcon } from "lucide-react";
import Image from "next/image";

import { darkGradient, lightGradient } from "./ctaButtonStyles";

export interface ValuePropositionCopy {
  header: {
    h2: string;
    h3: string;
    p: string;
    imageAlt: string;
  };
  values: {
    Icon: LucideIcon;
    title: string;
    description: string;
  }[];
}

export function ValueProposition({ copy }: { copy: ValuePropositionCopy }) {
  const { header, values } = copy;

  return (
    <section id="wartosci" className="py-24 bg-white">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          <div className="lg:w-1/2">
            <h2 className={`text-sm font-semibold bg-clip-text text-transparent uppercase tracking-widest mb-3`} style={{ backgroundImage: darkGradient }}>
              {header.h2}
            </h2>
            <h3 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-6">
              {header.h3}
            </h3>
            <p className="text-lg text-slate-600 mb-8">{header.p}</p>

            <div className="relative w-full h-80">
              <Image
                src="/bluetooth-landing/value-proposition.jpg"
                alt={header.imageAlt}
                fill
                className="rounded-2xl shadow-xl object-cover"
                sizes="(min-width: 1024px) 50vw, 100vw"
              />
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col gap-8">
            {values.map(({ Icon, title, description }) => (
              <div key={title} className="flex gap-4">
                <div>
                  <div className="flex-shrink-0 mt-1 relative">
                    <div className="w-12 h-12 rounded-full flex items-center justify-center opacity-40" style={{ backgroundImage: lightGradient }}/>
                    <Icon className="absolute w-6 h-6 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-gray-600" />
                  </div>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-slate-900 mb-2">
                    {title}
                  </h4>
                  <p className="text-slate-600">{description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
